import React, { lazy } from 'react';
import { Check, ArrowRight } from 'lucide-react';
export function AtmosphereSection() {
  return <section id="atmosphere" className="py-20 md:py-24 bg-background overflow-hidden" data-id="element-12">
      <div className="container mx-auto px-4" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-14">
          {/* Image Column */}
          <div className="relative order-2 lg:order-1" data-id="element-15">
            <div className="relative rounded-lg overflow-hidden border border-border shadow-2xl" data-id="element-16">
              <img src="https://oldmillrestaurant.ie/wp-content/uploads/photo-gallery/imported_from_media_libray/12308484_1072749212770403_344806488201243795_n.jpg?bwg=1552561670" alt="The Old Mill Bar Atmosphere" loading="lazy" className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700" data-id="element-17" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" data-id="element-18"></div>
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 border-l-2 border-b-2 border-primary/50 hidden md:block" data-id="element-19"></div>
            <div className="absolute -top-6 -right-6 w-24 h-24 border-r-2 border-t-2 border-primary/50 hidden md:block" data-id="element-20"></div>
          </div>

          {/* Content Column */}
          <div className="order-1 lg:order-2 space-y-8" data-id="element-21">
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-foreground leading-tight" data-id="element-22">
              Experience True <br data-id="element-23" />
              <span className="text-primary" data-id="element-24">Irish Hospitality</span>
            </h2>

            <p className="text-lg text-muted-foreground leading-relaxed" data-id="element-25">
              Located in the heart of Temple Bar, The Old Mill offers a warm,
              welcoming retreat from the bustling streets. Whether you're here
              for a quick pint or a full three-course meal, you'll feel right at
              home.
            </p>

            <ul className="space-y-4" data-id="element-26">
              {['Full Bar Available — craft beers, whiskeys, cocktails & wines', 'Warm Irish Hospitality — friendly staff, cozy atmosphere', "Perfect Stop in Dublin's Cultural Quarter — steps from Ha'penny Bridge"].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-27">
                  <div className="mt-1 w-5 h-5 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0" data-id="element-28">
                    <Check className="w-3 h-3 text-primary" data-id="element-29" />
                  </div>
                  <span className="text-foreground" data-id="element-30">{item}</span>
                </li>)}
            </ul>

            <div className="pt-4" data-id="element-31">
              <a href="https://oldmillrestaurant.ie/menus/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-primary font-bold hover:text-primary/80 transition-colors group" data-id="element-32">
                View Our Drinks Menu
                <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-33" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}